// About.js
import React from 'react';

export default function About() {
  return (
    <div className="bg-light py-5">
      <div className="container">
        <h2 className="text-center mb-4">💡 About Me</h2>
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <p className="lead">
                  I blend technical expertise with creative problem-solving to build solutions that transform how businesses operate. My work spans from enterprise AI systems to interactive AR applications, always focused on delivering real-world impact.
                </p>
                <div className="mt-4">
                  <h5>Mindset</h5>
                  <p>
                    I think outside the box, using both established and emerging technologies to turn ideas into reality. My focus is always on creating solutions that deliver tangible value—whether it's streamlining operations, enhancing user experiences, or solving complex domain-specific challenges.
                  </p>
                  <p>
                    What drives me is seeing the positive impact of technology when applied thoughtfully to real-world problems. I enjoy exploring diverse fields from healthcare and manufacturing to entertainment and data visualization, adapting my technical approach to deliver meaningful outcomes for people and organizations.
                  </p>
                </div>
                <div className="text-center mt-4">
                  <a className="btn btn-outline-primary" href="/assets/Efraim_Hernandez_Resume.pdf" download>
                    <i className="bi bi-file-earmark-text me-1"></i> Download My Resume
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}